import { Container } from 'inversify';
import { LoggerService } from './logger/logger.service';

export const commonContainer = new Container();

commonContainer.bind<LoggerService>(LoggerService).toSelf().inSingletonScope();
